/** Help articles: one Markdown file per topic and language, bundled with the app. */

const files = import.meta.glob<string>("./*/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

export const HELP_TOPICS = [
  "getting-started",
  "projects",
  "connection",
  "catalogue",
  "security",
  "ssh-keys",
  "servers",
  "networks",
  "firewalls",
  "server-create",
  "public-ips",
  "images",
  "volumes",
  "floating-ips",
  "placement-groups",
  "load-balancers",
  "certificates",
  "users",
  "autopilot",
  "api-access",
  "costs",
  "remote-desktop",
  "windows",
  "alerts",
  "monitoring",
  "assistant",
  "packages",
] as const;
export type HelpTopic = (typeof HELP_TOPICS)[number];

export function isHelpTopic(value: string): value is HelpTopic {
  return (HELP_TOPICS as readonly string[]).includes(value);
}

/** The article in the given language, falling back to English. */
export function helpArticle(topic: HelpTopic, language: string): string {
  const lang = language.startsWith("ru") ? "ru" : "en";
  return files[`./${lang}/${topic}.md`] ?? files[`./en/${topic}.md`] ?? "";
}

/** The article's first heading, used as the drawer title. */
export function helpTitle(source: string): string {
  return /^#\s+(.+)$/m.exec(source)?.[1] ?? "";
}

export const helpFiles = files;
